import './FacilitySupportTabs.less'
import { DownOutlined } from '@ant-design/icons'

import { Collapse } from 'antd'
import { useEffect, useState } from 'react'
import useStore from '@/hooks/useStore'
import { IGetSupportData } from '@/service/rightNavCtrl'

const RETURN = 'RETURN'
const WELFARE = 'WELFARE'

const map = new Map()
map.set('지원대상 및 자격조건', 'sprtTrgtAndQlfcCndCn')
map.set('사업내용', 'bizCn')
map.set('지원조건', 'sprtCndCn')
map.set('증빙서류', 'prufDcmntCn')
map.set('접수 및 문의처', 'cinfoCn')

const COLLAPSE_ARR = [
  { title: '지원대상 및 자격조건', value: 'sprtTrgtAndQlfcCndCn' },
  { title: '사업내용', value: 'bizCn' },
  { title: '지원조건', value: 'sprtCndCn' },
  { title: '증빙서류', value: 'prufDcmntCn' },
  { title: '접수 및 문의처', value: 'cinfoCn' },
]
function FacilitySupportTabs() {
  const facilityStore = useStore('facilityStore')

  const [collapseDataOne, setCollapseDataOne] = useState<any>([])
  const [collapseDataTwo, setCollapseDataTwo] = useState<any>([])
  const [noData, setNoData] = useState<boolean>(false)
  const [noData2, setNoData2] = useState<boolean>(false)

  useEffect(() => {
    if (!facilityStore.clickedSggCd)
      return
    init(facilityStore.clickedSggCd)
  }, [facilityStore.clickedSggCd])

  const init = async (sggCd: string) => {
    const obj = {
      apiKey: window.SystemConfig.facilityApiKey,
      sggCd,
    }
    const res: any = await IGetSupportData(obj)
    const { result = [] } = res
    const firstData = result.filter((item: any) => item.locgovSprtPolicySeCd === RETURN)
    const secondData = result.filter((item: any) => item.locgovSprtPolicySeCd === WELFARE)
    if (firstData.length > 0) {
      const res = handleCollapseData(firstData)
      setCollapseDataOne(res)
    }
    else {
      setNoData(true)
    }

    if (secondData.length > 0) {
      const res = handleCollapseData(secondData)
      setCollapseDataTwo(res)
    }
    else {
      setNoData2(true)
    }
  }

  const handleCollapseData = (fatherData: any) => {
    if (!fatherData || fatherData.length === 0)
      return
    const res = []

    for (let i = 0; i < fatherData.length; i++) {
      const item = fatherData[i]
      const obj: any = {
        label: item.detlBizNm,
        key: i,
        children: (
          <>
            {COLLAPSE_ARR.map((item2: any, index: number) => {
              return (
                <div className={'collapse-box'} key={index}>
                  <div className={'collapse-box-key'}>{item2.title}</div>
                  <div className={'collapse-box-value'}>{item[item2.value]}</div>
                </div>
              )
            })}
          </>
        ),
      }
      res.push(obj)
    }
    return res
  }

  const CollapseCom = (props: any) => {
    const { items } = props
    const onChange = (key: string | string[]) => {}
    return (
      <Collapse
        expandIcon={({ isActive }) => <DownOutlined rotate={isActive ? 180 : 0} />}
        bordered={false}
        accordion
        items={items}
        defaultActiveKey={['1']}
        onChange={onChange}
        expandIconPosition={'end'}
      />
    )
  }

  return (
    <div className={'FacilitySupportTabs'}>
      {/* <div className={'tablePart'}>
            <Descriptions label="지원정책" size={'small'} bordered items={table1Items} />
          </div> */}
      <div className={'one-box'}>
        <header>귀농귀촌 정책</header>
        {noData ? <header style={{ textAlign: 'center' }} >결과가 없습니다.</header> : <CollapseCom items={collapseDataOne} />}
      </div>
      <div className={'two-box'}>
        <header>사회복지 정책</header>
        {noData2 ? <header style={{ textAlign: 'center' }} >결과가 없습니다.</header> : <CollapseCom items={collapseDataTwo} />}
      </div>
    </div>
  )
}

export default FacilitySupportTabs
